
export default class Introduction{
    
    constructor() {
        this._init();
    }

    _init(){
        const $txt = document.querySelector('.js-introduction-text');

        document.querySelector('.js-introduction-more').addEventListener('click', ()=>{
            $txt.classList.toggle('-open');
        });
    }
}
